// extracted by mini-css-extract-plugin
export var bottom = "CookieConsent-module--bottom--VZsys";
export var bottomLeft = "CookieConsent-module--bottomLeft--ZW-ba";
export var bottomRight = "CookieConsent-module--bottomRight--e3AR9";
export var button = "CookieConsent-module--button--fjw+Y";
export var buttonApprove = "CookieConsent-module--button--approve--EYqMP";
export var buttonDecline = "CookieConsent-module--button--decline--bbRq+";
export var buttonGroup = "CookieConsent-module--button-group--N3Hkr";
export var component = "CookieConsent-module--component--EdKcK";
export var description = "CookieConsent-module--description--ktLGu";
export var more = "CookieConsent-module--more--dtU0e";
export var title = "CookieConsent-module--title--SwDPF";
export var top = "CookieConsent-module--top--UDXN2";
export var topLeft = "CookieConsent-module--topLeft--L37et";
export var topRight = "CookieConsent-module--topRight--cuNqs";